var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutGoingClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "202px",
    viewBox: "0 0 52 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u51FA\u7EBF\u56DE\u8DEF-\u95ED\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    transform: "translate(-1069.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u51FA\\u7EBF\\u56DE\\u8DEF-\\u95ED\\u5408",
    transform: "translate(1070.000000, 761.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(0.000000, 50.000000)",
    stroke: "#52C41A",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-3",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u76F4\\u7EBF-7",
    transform: "translate(26.500000, 13.000000) scale(-1, 1) translate(-26.500000, -13.000000) ",
    points: "6.5 2.44249065e-15 46.5 0 46.5 26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-43",
    transform: "translate(6.500000, 0.000000)",
    stroke: "#E64242",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -5.32560107e-14,
    x2: 40,
    y2: 50,
    id: "\\u76F4\\u7EBF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 50,
    x2: 40,
    y2: 66,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 144,
    x2: 40,
    y2: 200,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 90,
    x2: 40,
    y2: 106,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-7",
    points: "40 128 40 144 -4.16333634e-16 144 0 110 8.5 90.5 11 90.5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2",
    fill: "#FF4D4F",
    x: 42,
    y: 66,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-6",
    fill: "#FF4D4F",
    x: 42,
    y: 106,
    width: 9,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutGoingClose);
export default __webpack_public_path__ + "static/media/outGoing_close.db2069387e4fadc4b55f9b37f6b5cbf4.svg";
export { ForwardRef as ReactComponent };